import { AfterViewInit, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { GridOptions } from 'ag-grid';
import { Observable } from 'rxjs/Observable';
import { PayorInterface } from '../../../../core/interfaces/payor.interface';
import { IResponseSuccess, ResponseInterface } from '../../../../core/interfaces/response.interface';
import { RiderPayorDetailInterface } from '../../../../core/interfaces/rider-payor-detail.interface';
import { RiderPayorInterface } from '../../../../core/interfaces/rider-payor.interface';
import { RiderPayorService } from '../../../../core/services/rider-payor.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { ParentModule } from '../../../A2-utils/ParentClass/parent-module';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-rider-payor',
  templateUrl: './rider-payor.component.html',
  styleUrls: ['./rider-payor.component.scss']
})
export class RiderPayorComponent extends ParentModule implements OnInit, OnDestroy, AfterViewInit {

  @Input() riderForm: FormGroup;
  @Input() payors: Observable<PayorInterface[]>;
  @ViewChild('riderPayorT2Card') riderPayorT2Card: T2CardComponent;
  protected selectPayor: PayorInterface[];
  protected grid: GridOptions;
  protected riderPayorForm: FormGroup;
  protected json = {
    payorid: '',
    riderid: '',
    riderpayorid: '',
    memberid: '',
    description: '',
    enableplans: '',
    isactive: true,
    isdefault: true,
    medicaidnumber: '',
    riderpayordetails: this.fb.array([]),
  };
  private rowIndex: number;
  buttonDisabled = false;
  payorSelected;
  @Output() emitPut: EventEmitter <boolean> = new EventEmitter <boolean>();
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private _riderPayorService: RiderPayorService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-rider-payor', Inject);
  }

  ngOnInit() {
    this.payors.subscribe(resp => this.selectPayor = resp);
    this.riderPayorForm = this.addFbGroup(this.json);
    this.addDescriptionPayor();
    this.columDefs();
  }

  private columDefs() {
    this.grid = <GridOptions>{
      enableSorting: true,
      enableFilter: true,
      enableColResize: true,
      columnDefs: [
        {
          headerName: 'IdPayor',
          field: 'payorid',
          width: 20,
          hide: true,
        },
        {
          headerName: '',
          field: 'select',
          checkboxSelection: true,
          width: 40
        },
        {
          cellClass: 't2-cursorPointer textAlignCenter',
          headerName: 'Def',
          field: 'isdefault',
          width: 70,
          cellRendererFramework: BooleanCheckComponent,
        },
        {
          headerName: 'Payor',
          field: 'description',
          width: 200
        },
        {
          headerName: 'Policy',
          field: 'memberid',
          width: 200
        },
        {
          headerName: 'Active',
          field: 'isactive',
          width: 70,
          cellRendererFramework: BooleanCheckComponent
        },
      ],
      onGridReady: () => {
        this.grid.api.sizeColumnsToFit();
      }
    };
  }

  addFbGroup(json) {
    return this.fb.group(json);
  }

  add() {
    this.valueChanges();
    this.riderPayorT2Card.open();
    if (this.riderPayorForm.get('payorid').value) {
      this.riderPayorForm.get('payorid').disable();
    }
  }

  remove() {
    if (this.grid.api.getSelectedNodes().length) {
      const rowSelect = this.grid.api.getSelectedNodes()[0];
      this.sweetAlertHelper.createCustomAlert({
        title: 'Are you sure?',
        text: 'You want to permanently delete the selected element?',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'No',
        cancelButtonText: 'Yes'
      }).then((result) => {
        if (!result.value) {
          if (rowSelect.data.riderpayorid && rowSelect.data.riderid) {
            rowSelect.data.riderpayordetails = [];
            rowSelect.data.isactive = false;
            this.subscriptions.push(
              this._riderPayorService.put(rowSelect.data).subscribe((resp: ResponseInterface) => {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Success',
                  text: resp.message,
                  type: 'success'
                }).then(() => {
                  this.emitPut.emit(true);
                });
              }, (error: ResponseInterface) => this.sweetAlertHelper.captureException(error))
            );
          } else {
            this.riderPayorArray.removeAt(rowSelect.rowIndex);
          }
        }
      });
    } else {
      this.sweetAlertHelper.createCustomAlert({ title: 'Select Record', type: 'warning' });
    }
  }

  save() {
    this.riderPayorForm.get('payorid').enable();
    const value = this.riderPayorForm.value;
    const riderPayorId = this.riderPayorForm.get('riderpayorid').value;
    const riderId = this.riderPayorForm.get('riderid').value;
    const rowIndex = this.rowIndex;
    if (riderPayorId && riderId) {
      this.buttonDisabled = true;
      value.riderpayordetails = [];
      this.subscriptions.push(
        this._riderPayorService.put(value).subscribe((resp: IResponseSuccess) => {
          this.respRiderPayorService(resp);
        }, (error: ResponseInterface) => {
          this.sweetAlertHelper.captureException(error).then(() => {
            this.buttonDisabled = false;
          });
        })
      );
    } else if (!riderPayorId && riderId) {
      this.buttonDisabled = true;
      this.subscriptions.push(
        this._riderPayorService.post(value).subscribe((resp: IResponseSuccess) => {
          this.respRiderPayorService(resp);
        }, (error: ResponseInterface) => {
          this.sweetAlertHelper.captureException(error).then(() => {
            this.buttonDisabled = false;
          });
        })
      );
    } else {
      if (value.isdefault && rowIndex === undefined) {
        const arrayAux = [];
        this.grid.api.forEachNode((rowNode) => {
          arrayAux.push(rowNode.data.payorid);
          if (rowNode.childIndex != rowIndex) {
            if (rowNode.data.payorid !== value.payorid && !arrayAux.includes(value.payorid)) {
              this.riderPayorArray.at(rowNode.childIndex).patchValue({ isdefault: false });
            }
          }
        });
      }

      if (rowIndex !== undefined) {
        const data = this.riderPayorForm.value;
        data.payorid = this.payorSelected.payorid;
        this.riderPayorForm.get('payorid').disable();
        if (this.riderPayorForm.get('isdefault').value) {
          this.grid.api.forEachNode((rowNode) => {
            if (rowNode.data) {
              if (rowNode.data.payorid !== this.payorSelected.payorid) {
                rowNode.data.isdefault = false;
                this.riderPayorArray.at(rowNode.childIndex).patchValue(rowNode.data);
              } else {
                rowNode.data.isdefault = this.riderPayorForm.get('isdefault').value;
                this.riderPayorArray.at(rowNode.childIndex).patchValue(data);
              }

            }
          });
        } else {
          this.riderPayorArray.at(rowIndex).patchValue(data);
        }
        //  this.riderPayorArray.removeAt(rowIndex);
      }

      let addArray = true;
      if (this.grid.api && rowIndex === undefined) {
        this.grid.api.forEachNode((rowNode) => {
          if (rowNode) {
            if (rowNode.data.payorid === value.payorid) {
              addArray = false;
              this.sweetAlertHelper.createCustomAlert({ title: 'Duplicate Payor', type: 'error' });
            }
          }
        });
        if (addArray) {
          this.riderPayorArray.push(this.addFbGroupArray(value));
        }
      }
    }
    // this.riderPayorArray.push(this.addFbGroupArray(value));
    // this.riderPayorT2Card.close();
  }

  getRowNodeId = (data)  => {
    return data.payorid;
  }

  respRiderPayorService(resp: IResponseSuccess) {
    this.sweetAlertHelper.createCustomAlert(
      {
        title: 'Succes',
        text: resp.message,
        type: 'success'
      }).then(() => {
        this.emitPut.emit(true);
        this.buttonDisabled = false;
      });
  }

  addFbGroupArray(data) {
    return this.fb.group({
      riderid: data.riderid,
      payorid: data.payorid,
      riderpayorid: data.riderpayorid,
      description: data.description,
      memberid: data.memberid,
      isactive: data.isactive,
      isdefault: data.isdefault,
      medicaidnumber: data.medicaidnumber,
      enableplans: data.enableplans,
      riderpayordetails: this.addFbArray(data.riderpayordetails)
    });
  }

  addFbArray(data) {
    let a = new FormArray([]);
    if (data.length) {
      data.forEach(x => {
        a.push(this.addFbGroup({
          riderpayordetailid: x.riderpayordetailid,
          riderpayorid: x.riderpayorid,
          groupid: x.groupid,
          startdate: x.startdate,
          expirationdate: x.expirationdate,
          planid: x.planid,
          isltc: x.isltc,
          tripsqty: x.tripsqty,
          createdon: x.createdon,
          modifiedonformatted: x.modifiedonformatted
        }));
      });
      return a;
    } else {
      return a;
    }
  }

  resetFormRiderPayor() {
    this.riderPayorForm.reset();
    while (this.riderPayorDetailFormArray.length !== 0) {
      this.riderPayorDetailFormArray.removeAt(0)
    }
    this.riderPayorForm.patchValue({ 'isactive': true , 'isdefault': true });
  }

  get riderPayorDetailFormArray(): FormArray {
    return this.riderPayorForm.get('riderpayordetails') as FormArray;
  }

  get riderPayorArray(): FormArray {
    return this.riderForm.get('riderpayors') as FormArray;
  }

  addDescriptionPayor(): void{
    this.riderPayorForm.get('payorid').valueChanges.subscribe(value => {
      if (value !== null) {
        let payorDescription = this.selectPayor.filter((data) => { return data.payorid == value});
        if (payorDescription.length) {
          this.riderPayorForm.patchValue({description: payorDescription[0].description});
        }
      }
    });
  }

  edit($event: any) {
    this.payorSelected = $event.data;
    this.rowIndex = $event.rowIndex;
    this.loadRiderPayor($event.data);
    this.add();
  }

  loadRiderPayor(riderpayor: RiderPayorInterface) {
    this.riderPayorForm.patchValue(riderpayor);
    this.addEditRider(riderpayor.riderpayordetails);
  }

  addEditRider(rdierpayordetail: RiderPayorDetailInterface[]) {
    if (rdierpayordetail.length) {
      rdierpayordetail.forEach(x => {
        this.riderPayorDetailFormArray.push(this.addFbGroup({
          riderpayordetailid: x.riderpayordetailid,
          riderpayorid: x.riderpayorid,
          groupid: x.groupid,
          startdate: x.startdate,
          expirationdate: x.expirationdate,
          planid: x.planid,
          isltc: x.isltc,
          tripsqty: x.tripsqty,
          createdon: x.createdon,
          modifiedonformatted: x.modifiedonformatted
        }));
      });
    }
  }

  emitterActionCard($event: any) {
    if (!$event.isOpen) {
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
      this.resetFormRiderPayor();
      this.rowIndex = undefined;
      this.riderPayorForm.get('payorid').enable();
      this.riderPayorForm.get('payorid').setValue('');
    }
  }

  private valueChanges() {
    if (this.riderForm.get('riderid').value) {
      this.riderPayorForm.patchValue({riderid: this.riderForm.get('riderid').value});
    }

    this.subscriptions.push(
      this.riderForm.get('riderid').valueChanges.subscribe(val => {
        if (val !== null) {
          this.riderPayorForm.patchValue({riderid: val});
        }
      }),
      this.riderPayorForm.get('riderpayorid').valueChanges.subscribe(val => {
        if (val !== null) {
          this.riderPayorForm.get('payorid').disable();
        } else {
          this.riderPayorForm.get('payorid').enable();
        }
      })
    );
  }

  idRider($event){
    this.emitPut.emit($event);
  }

  get disableBtnSave(): boolean {
    return this.buttonDisabled;
  }

  get isInactive(): boolean {
    return this.riderForm.get('isinactive').value;
  }

  ngAfterViewInit(): void {
    this.grid.api.sizeColumnsToFit();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-payor/rider-payor.component.ts